import { render, staticRenderFns } from "./e-two-values-table-column-text.vue?vue&type=template&id=930a45ba&scoped=true&lang=pug"
import script from "./e-two-values-table-column-text.vue?vue&type=script&lang=js"
export * from "./e-two-values-table-column-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930a45ba",
  null
  
)

export default component.exports